import { UploadOutlined } from "@ant-design/icons";
import { Button, Col, Form, Modal, Row, Space, Upload } from "antd";
import { useTranslation } from "react-i18next";
import { normFile } from "utils/";

export default function ModalImport({ form, loading, onFinish, show, onCancel }) {
    const { t } = useTranslation()

    return (
        <Modal
            open={show}
            onCancel={onCancel}
            title={t('import')}
            footer=''
            width={800}
        >
            <Form form={form} onFinish={onFinish} layout='vertical'>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            name="upload"
                            rules={[{ required: true }]}
                            label="File excel"
                            valuePropName="fileList"
                            getValueFromEvent={normFile}
                        >
                            <Upload
                                name="logo"
                                listType="picture"
                                accept=".xlsx"
                                maxCount={1}>
                                <Button icon={<UploadOutlined />}>{t('upload')}</Button>
                            </Upload>
                        </Form.Item>
                    </Col>
                    <Form.Item>
                        <Space>
                            <Button loading={loading} htmlType="submit" type='primary' size='large'>
                                {t('import')}
                            </Button>
                            <Button loading={loading} size='large' onClick={onCancel}>
                                {t('cancel')}
                            </Button>
                        </Space>
                    </Form.Item>
                </Row>
            </Form >
        </Modal >
    )
}